export const scrollPage=(e)=>{
    const sitePromo=document.getElementById("site_promo");
    if(sitePromo.classList.contains("closeInfo")){
        return
    }else{
        const arrowElement = sitePromo.getElementsByClassName("arrow")[0];
        arrowElement.classList.add("arrow_down");
        arrowElement.classList.remove("arrow_up"); 
        setTimeout(function(){
            $("#site_promo").animate({"bottom":-($("#site_promo").height()-$("#site_promo .title").height())});
        },300);
        sitePromo.classList.add("closeInfo");
        sitePromo.classList.remove("openInfo")
    }
}
